import * as React from "react";
import { Component, ErrorInfo, FC, FunctionComponent, PropsWithChildren } from "react";
import { AckHeader } from "./AckHeader";
import { AckFooter } from "./AckFooter";
import { AckAuthProvider } from "./security/AckAuth";

class ErrorBoundary extends Component<PropsWithChildren<{ sitename: string }>, {
  error: Error | undefined,
  errorInfo: ErrorInfo | undefined
}> {
  constructor(props: any) {
    super(props);
    this.state = { error: undefined, errorInfo: undefined };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error: error, errorInfo: errorInfo });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="section">
          <div className="content">
            <h1 className="subtitle is-4">Ackbox {this.props.sitename}</h1>
            <h1 className="title is-3 is-spaced">Something went wrong.</h1>
            <br/>
            <h3 className="subtitle is-5 is-spaced">Message:</h3>
            <pre>{this.state.error?.message}</pre>
            <br/>
            <h3 className="subtitle is-5 is-spaced">Details:</h3>
            <pre>{this.state.error?.stack}</pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export type AckPagePros = {
  settings: AckSettings;
}

export type AckSettings = {
  authAudience: string;
  authScope: string;
  sitename: string;
  navigation: FunctionComponent;
}

export const AckPage: FC<PropsWithChildren<AckPagePros>> = (props) => {
  document.title = `Ackbox ${props.settings.sitename}`;
  const settings = props.settings;
  const Navigation = settings.navigation;
  return (
    <ErrorBoundary sitename={props.settings.sitename}>
      <AckAuthProvider audience={settings.authAudience} scope={settings.authScope}>
        <AckHeader sitename={settings.sitename}>
          <Navigation/>
        </AckHeader>
        {props.children}
        <AckFooter sitename={settings.sitename}/>
      </AckAuthProvider>
    </ErrorBoundary>
  );
};
